import { z } from 'zod'
import { apiClient, handleResponse } from "@/utils/axios-client.ts";

export const CompanyTokenResponseSchema = z.object({
  accessToken: z.string(),
  tokenType: z.literal('Bearer'),
  expiresAt: z.number().transform(epoch => new Date(epoch * 1000)), // Unix epoch to Date
  companyId: z.number()
})

export type CompanyTokenResponse = z.infer<typeof CompanyTokenResponseSchema>

/**
 * Exchange a Firebase JWT token for a company-scoped access token.
 *
 * This is the ONLY API call that should use the Firebase JWT token.
 * All other business API calls should use the company token.
 *
 * @param companyId The ID of the company to get a token for
 * @param firebaseToken The Firebase ID token
 * @returns Company token response with accessToken, expiresAt, etc.
 */
export async function exchangeFirebaseToken(
  companyId: string,
  firebaseToken: string
): Promise<CompanyTokenResponse> {
  // Use a direct axios call to bypass the normal interceptor
  // This ensures we use the Firebase token, not the company token
  return handleResponse(
    () =>
      apiClient.post(`/api/v1/companies/${companyId}/token`, undefined, {
        headers: {
          Authorization: `Bearer ${firebaseToken}`
        }
      }),
    CompanyTokenResponseSchema
  )
}
